import React from 'react';
import './OfflineInstructions.css';

import { FaCircleNotch } from 'react-icons/fa';

const OfflineInstructions = () => {
    return (
        <>
            <p>Please follow the instructions below to make an offline donation to <strong>Siraj Islamic Center:</strong></p>

            <ol>
                <li>
                    <strong>Bank Transfer:</strong>
                    <ul>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Bank Name:</strong> Islamic Community Bank</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Account Name:</strong> Siraj Islamic Center Fund</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Account Number:</strong> 1234567890</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>Branch:</strong> Main Islamic Branch</li>
                        <li><div className='icon'><FaCircleNotch /></div> <strong>IFSC Code:</strong> ICB0012345</li>
                    </ul>
                </li>
                <li>
                    <strong>Cheque:</strong>
                    <ul>
                        <li>Make payable to: <strong>Siraj Islamic Center Fund</strong></li>
                        <li>Mail to: <strong>123 Peace Avenue, Muslim Town, ZIP 54321</strong></li>
                    </ul>
                </li>
                <li>
                    <strong>Cash:</strong>
                    <ul>
                        <li>Visit: <strong>123 Peace Avenue, Muslim Town, ZIP 54321</strong></li>
                        <li>Hours: <strong>Monday-Friday, 9:00 AM - 5:00 PM</strong></li>
                    </ul>
                </li>
            </ol>
        </>
    );
}

export default OfflineInstructions;